// extracted by mini-css-extract-plugin
module.exports = {"label":"_1k8rq","problemStatuses":"K-3id","statusBox":"_1MSAh","active":"_3muoX","statusTitle":"_2r0D8","icon":"FYY-L"};